import { render, staticRenderFns } from "./UploadBuktiTransfer.html?vue&type=template&id=70c2c117&scoped=true&"
import script from "./UploadBuktiTransfer.js?vue&type=script&lang=js&"
export * from "./UploadBuktiTransfer.js?vue&type=script&lang=js&"
import style0 from "./UploadBuktiTransfer.scss?vue&type=style&index=0&id=70c2c117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2c117",
  null
  
)

export default component.exports